import React, { useState } from 'react';
import { LocalizationModel } from './LocalizationModel';
import { validateValue } from '../../../common/utils/validate';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import showAlert from '../../../common/utils/alert';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';

export const LocalizationTableRow = ({
  projectId,
  languageKeyValue,
  updateLocalizationKeyValue,
  deleteLocalizationKeyValue,
  deleteFlag,
}) => {
  const [toggle, setToggle] = useState(false);
  const { key, value, uuid } = languageKeyValue;

  const handleDelete = (key) => {
    const preConfirm = () => deleteLocalizationKeyValue({ projectId, key });
    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!');
  };

  const handleEdit = (values) => {
    const { value } = values;
    updateLocalizationKeyValue({ projectId, key, value, uuid });
  };

  const showEditConfigModel = (value) => {
    return (
      <LocalizationModel title={'Edit Value'} toggle={toggle} setToggle={setToggle}>
        <Formik initialValues={{ value }} onSubmit={handleEdit}>
          <Form className="form-horizontal">
            <div className="row mx-auto">
              <div className="col-md-8 col-lg-8 col-sm-8 col-xs-8">
                <CustomInputWithIcon icon="text" required={true}>
                  <Field
                    type="text"
                    name="value"
                    className="form-control form-control-sm"
                    placeholder="Value"
                    validate={validateValue}
                  />
                  <ErrorMessage name="value">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </CustomInputWithIcon>
              </div>
              <div className="col-md-4 col-lg-4 mt-2 text-right">
                <button className="btn btn-theme-submit btn-md" type="submit">
                  <i className={`wb ${drapcodeIcon('add')}`}></i>&nbsp;Update Value&nbsp;
                </button>
              </div>
            </div>
          </Form>
        </Formik>
      </LocalizationModel>
    );
  };
  return (
    <tr key={key}>
      {showEditConfigModel(value)}
      <td>{key}</td>
      <td>{value}</td>
      <td>
        &nbsp;
        <button
          type="button"
          className="btn btn-primary btn-xs"
          title="Edit"
          onClick={() => setToggle(true)}
        >
          <i className="wb webconnect-edit" />
        </button>
        &nbsp;
        <button
          type="button"
          className="btn btn-theme-delete btn-xs"
          style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
          title="Delete"
          onClick={() => (deleteFlag ? handleDelete(key) : undefined)}
        >
          <i className="wb webconnect-trash-regular" />
          {deleteFlag ? null : (
            <>
              &nbsp;
              <TooltipInfo
                title={description}
                headerText={`Permission Disabled!`}
                showHeader={true}
                showArrow={true}
              />
            </>
          )}
        </button>
      </td>
    </tr>
  );
};
